// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Graph = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 128 133"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g filter="url(#Graph_tsx__a)">
			<ellipse cx={68.366} cy={124.5} rx={55.5} ry={4.5} fill="url(#Graph_tsx__b)" fillOpacity={0.5} />
		</g>
		<rect
			x={0.709}
			y={18.036}
			width={106.451}
			height={105.505}
			rx={7.5}
			transform="rotate(-9.44 .709 18.036)"
			fill="#fff"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M86.704 13.392a2 2 0 0 0-1.645 2.3l13.525 81.34a2 2 0 0 0 2.301 1.645l9.879-1.642a2 2 0 0 0 1.645-2.301l-13.525-81.34a2 2 0 0 0-2.3-1.645l-9.88 1.643Zm-16.79 25.142a2 2 0 0 1 1.644-2.3l9.88-1.644a2 2 0 0 1 2.3 1.645L93.976 97.8a2 2 0 0 1-1.644 2.301l-9.88 1.643a2 2 0 0 1-2.301-1.645L69.913 38.534ZM57.645 66.491A2 2 0 0 0 56 68.79l5.715 34.372a2 2 0 0 0 2.3 1.645l9.88-1.643a2 2 0 0 0 1.645-2.301l-5.715-34.371a2 2 0 0 0-2.3-1.645l-9.88 1.643ZM40.033 86.689a2 2 0 0 1 1.645-2.3l9.88-1.643a2 2 0 0 1 2.3 1.645l3.25 19.538a2 2 0 0 1-1.645 2.301l-9.88 1.643a2 2 0 0 1-2.301-1.645l-3.249-19.539ZM23.038 98.407a2 2 0 0 1 1.645-2.301l9.88-1.643a2 2 0 0 1 2.3 1.645l1.81 10.886a2 2 0 0 1-1.644 2.301l-9.88 1.643a2 2 0 0 1-2.301-1.645l-1.81-10.886Z"
			fill="url(#Graph_tsx__c)"
		/>
		<rect
			x={0.709}
			y={18.036}
			width={106.451}
			height={105.505}
			rx={7.5}
			transform="rotate(-9.44 .709 18.036)"
			stroke="url(#Graph_tsx__d)"
		/>
		<defs>
			<linearGradient
				id="Graph_tsx__b"
				x1={19.507}
				y1={125}
				x2={122.443}
				y2={125}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#C4C4C4" />
				<stop offset={1} stopColor="#C4C4C4" stopOpacity={0.37} />
			</linearGradient>
			<linearGradient
				id="Graph_tsx__c"
				x1={70.134}
				y1={-8}
				x2={68.957}
				y2={103.986}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#C4C4C4" stopOpacity={0.1} />
				<stop offset={1} stopColor="#C4C4C4" />
			</linearGradient>
			<linearGradient
				id="Graph_tsx__d"
				x1={90.555}
				y1={14.793}
				x2={24.015}
				y2={122.335}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#D3D3D3" />
				<stop offset={1} stopColor="#AAA" />
			</linearGradient>
			<filter
				id="Graph_tsx__a"
				x={8.866}
				y={116}
				width={119}
				height={17}
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
			</filter>
		</defs>
	</svg>
);
export default Graph;
